import { Injectable } from '@angular/core';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { ContainerHeightCalculatorService } from './container-height-calculator.service';
import { ListService } from './list.service';
import { UniversalService } from './universal.service';

@Injectable({
  providedIn: 'root'
})
export class DirectivesService {
  constructor(private universalService:UniversalService, private listService:ListService, private reCalcService:ContainerHeightCalculatorService ) {}

  emitMoveOpertion(){
    var movingToSameFolder = false;
    // this.universalService.withinAppDraggedFolder["parentObjectKey"] = this.currentFolder["objectKey"];
    
    this.universalService.selectedNodes.map(obj=>{
      var ob = obj["FullObject"] ? obj["FullObject"] : obj
      ob["parentObjectKey"] = this.universalService.destinationFolder["objectKey"];
      if(!this.universalService.destinationFolder["objectKey"] || (ob["objectKey"] == this.universalService.destinationFolder["objectKey"])){
        movingToSameFolder = true;
      }
    })
    if(movingToSameFolder){
      $('.ag-row').removeClass('disable-row'); // for list view
      // $('.folder-wrap').removeClass('disable-row'); // for grid view
      $(".gridItem").removeClass("disable-row");
      $(".fileThumbnail").removeClass("disable-row");
      this.universalService.destinationFolder = {"objectName":"JioAICloud"};
      this.universalService.dragDropWithinApp = false;
      if(this.universalService.listView){
        // this condition is to know the rows checked on the list view
        var selectedRows = this.listService.listOptions.api.getSelectedRows();
        if(selectedRows.length == 0){
          this.listService.deSelectAll(null);
        }
      }
      
      return
    }
    // this.universalService.withinAppDraggedFolder["parentObjectKey"] = this.universalService.destinationFolder["objectKey"];
    var object={
      "files":this.universalService.selectedNodes,
      "operation":"MOVE",
      "correlationId": USER_DETAILS["USER_DETAILS"]["userId"]
    }
    AppEvents.globalObservable.next({"object":object,"destinationFolder":this.universalService.destinationFolder,"FileOpType":"move"});
  }


  initiateUpload(event){
      var droppedFileReadersArray = [];
      var droppedFilesArray = [];
      var size = 0;
      for (let i = 0; i < event.dataTransfer.files.length; i++) {
        size = size + parseInt(event.dataTransfer.files[i]["size"]);
      }
      var GB = (size)/(1024*1024*1024);
      if(GB >= ENV_CONSTANTS["constants"]["maxFileSizeForDragAndDrop"]){
        this.universalService.showToast("Please select less than " + ENV_CONSTANTS["constants"]["maxFileSizeForDragAndDrop"] + " GB to initiate upload","error");
        return
      }
      if(event.dataTransfer.files.length >= ENV_CONSTANTS["constants"]["maxFileCountForDragAndDrop"]){
        this.universalService.showToast("Please select less than " + ENV_CONSTANTS["constants"]["maxFileCountForDragAndDrop"] + " items to initiate upload","error");
        return
      }
      try {
        for (let i = 0; i < event.dataTransfer.files.length; i++) { // iterate in the files dropped4
        var f = event.dataTransfer.files[i];
        if (!f.type) {
            if (event.dataTransfer && event.dataTransfer.items && event.dataTransfer.items[i] && event.dataTransfer.items[i].webkitGetAsEntry()) {
            if (event.dataTransfer.items[i].webkitGetAsEntry().isDirectory) {
                event.dataTransfer.files[i]["IsFolder"] = true;
                    }
                }
            }
        }
        var dataList = event.dataTransfer.items
        for (var k = 0;k<dataList.length;k++) {
          if(dataList[k]["kind"] != 'string' ){
            var entry = dataList[k].getAsFile();
            droppedFilesArray.push(entry);
            droppedFileReadersArray[k] = dataList[k].webkitGetAsEntry();
          }
        }
    } catch(e){
        console.log('initiate upload error from directives service ',e);
  }
    AppEvents.globalObservable.next({"event":event, "droppedFileReadersArray":droppedFileReadersArray, "droppedFilesArray":droppedFilesArray});
  }


  setDragObjectName(obj){
    var objectName = obj["objectName"];
    if(objectName.length > 20){
      objectName = objectName.slice(0, 20) + "..."
    }else{
      objectName = objectName
    }
    return objectName;
  }
}
